export default "__VITE_ASSET__d3ac6025__"